import { ActDoc } from './../../../shared/models/models';
import { ServerService, IBuildProcess, IInfoStage, IInfoPercent } from '../../../shared/services/server.service';
import { IInfoVersionEX, IMainLineChart } from '../../main-line-chart/main-line-chart.component';
import { ISpot, ISpotWrapper, IStage, IObject, SetBuilding, WallMaterialType, RoomType, SpotRank } from '../../../shared/models/models';
import { EventService } from '../../../shared/services/event.service';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { UserInfo } from '../../header/header.component';
import * as moment from 'moment';
import { DateFormatPipe } from '../../../shared/pipes/date-format.pipe';
import { ToastrService } from 'ngx-toastr';

@Component({
	selector: 'app-object-construction',
	templateUrl: './object-construction.component.html',
	styleUrls: ['./object-construction.component.scss']
})
export class ObjectConstructionComponent implements OnInit {
	user: UserInfo = null;
	spots: ISpot[] = [];
	stages: IStage[] = [];
	completeDates = null;
	years: number[] = [];
	calendarTitleTemplate = 'Процент завершенности {stage} этапа';
	calendarTitle: string = '';
	calendarModal: boolean = false;
	periodModal: boolean = false;
	chartModal: boolean = false;
	loading: boolean = false;
	stageLoading: boolean = false;
	activeSpot: ISpot = null;
	activeStage: IStage = null;
	data: ISpotWrapper[] = [];
	selectedSpotIndex: number;
	startCalendarModal: boolean = false;
	endCalendarModal: boolean = false;
	selectedSpotId: number = 0;
	selectedFlorInfo: IConstructionInfo[];
	selectedIndex: number = 0;
	infoTitle = [
		{ title: 'Операции подразделов' },
		{ title: 'Производственный показатель' },
		{ title: 'Исполнение , %' },
		{ title: 'Факт' },
		{ title: 'Общий план' },
		{ title: 'Дата начала' },
		{ title: 'Дата окончания' },
		{ title: 'Статус' }
	];
	floorID: number;
	openedTreeInfo: IConstructionInfo[];
	currentStartCalendar: IConstructionInfo;
	spotColors = [];
	yearArr = [];
	ibuildingInfo: IBuildProcess = null;
	igraphicFactData: IMainLineChart[] = [];
	iinfoversion: IInfoVersionEX[] = [];
	buildingsInfoForLicense: BuildingInfoForLicense[] = [];
	foundSpot: BuildingInfoForLicense;
	selectedSpot: ISpot = null;
	selectedPlanInput: number;
	sendLocalKey = 'Item';
	getLocalItem: string;
	openedSpotInfo: ISpot[] = [];

	object: IObject = null;
	livingComplexID;
	wallMaterialTypes: WallMaterialType[] = [];
	buildingRoomTypes: RoomType[] = [];

	buildingClasses: SpotRank[] = [];

	actCalendar: boolean = false;

	spotDocDate: number;

	disCalendar: boolean = false;

	problemsQuestion: string;
	problem: boolean = false;

	constructor(
		private route: ActivatedRoute,
		private serverService: ServerService,
		private event: EventService,
		private dateFormat: DateFormatPipe,
		public toastr: ToastrService
	) { }

	ngOnInit() {
		this.loadSpotNotFullVersion();
		this.getPortalLicense();
		this.route.parent.params.subscribe((params) => {
			this.livingComplexID = params.id;
		});

		this.route.parent.params.subscribe((params) => {
			if (params.id > 0) {
				this.getObject(params);
			}
		});
	}
	getWallMaterialItems(materials: WallMaterialType[]) {
		for (let item of materials) {
			this.serverService.getWallMaterials(item.id).then((resp) => {
				item.wall_material = resp;
				for (let material of item.wall_material) {
					material.checked = false;
				}
				item.active = item.id === 1;
			});
		}
	}

	getBuildingOtherRooms(building_rooms: RoomType[]) {
		for (let item of building_rooms) {
			this.serverService.getBuildingRooms(item.id).then((resp) => {
				item.type = resp;
				item.modal = false;
			});
		}
	}

	getObject(params) {
		this.loading = false;
		this.serverService.getObject(params.id).then((res) => {
			this.object = res;
			this.loading = true;

		});
	}
	spotForm: boolean = false;
	addSpot() {
		if (this.wallMaterialTypes.length == 0) {
			this.serverService.getWallMaterialTypes().then((res) => {
				this.wallMaterialTypes = res;
				this.getWallMaterialItems(this.wallMaterialTypes);
			});
		}
		if (this.buildingRoomTypes.length == 0) {
			this.serverService.getBuildingRoomTypes().then((res) => {
				this.buildingRoomTypes = res;
				this.getBuildingOtherRooms(this.buildingRoomTypes);
			});
		}
		if (this.buildingClasses.length == 0) {
			this.serverService.getBuildingClasses().then((res) => {
				this.buildingClasses = res;
			});
		}
		this.route.parent.params.subscribe((params) => {
			// this.livingComplexID = params.id;
			if (this.livingComplexID !== 0) {
				let new_spot = {
					id: 0,
					number: '',
					floors: null,
					apartment_number: 0,
					developer_id: 0,
					developer_title: '',
					total_area: 0,
					rank: '',
					rank_id: 0,
					homeNumber: '',
					hasMansard: false,
					totalFlatAmount: null,
					totalFlatArea: 0,
					realisationPercent: 0,
					residueFlatCount: 0,
					isOpen: true,
					docs: [],
					stages: [
						{
							number: 1,
							complete: 0,
							start_date: null,
							end_date: null,
							isOpen: false
						},
						{
							number: 2,
							complete: 0,
							start_date: null,
							end_date: null,
							isOpen: false
						},
						{
							number: 3,
							complete: 0,
							start_date: null,
							end_date: null,
							isOpen: false
						},
						{
							number: 4,
							complete: 0,
							start_date: null,
							end_date: null,
							isOpen: false
						},
						{
							number: 5,
							complete: 0,
							start_date: null,
							end_date: null,
							isOpen: false
						},
						{
							number: 6,
							complete: 0,
							start_date: null,
							end_date: null,
							isOpen: false
						},
						{
							number: 7,
							complete: 0,
							start_date: null,
							end_date: null,
							isOpen: false
						},
						{
							number: 8,
							complete: 0,
							start_date: null,
							end_date: null,
							isOpen: false
						}
					]
				};
				this.spots.push(new_spot);

				let building: SetBuilding = {
					LivingComplexID: this.livingComplexID,
					BuildingNumber: null,
					FloorCount: 0,
					FlatCount: 0,
					HomeNumber: null,
					HasMansard: false
				};
				this.serverService.setBuilding(building).then((res) => {
					new_spot.id = res;
					this.allowAccesForFullVersion(this.buildingsInfoForLicense, new_spot);
					this.spotForm = true;
					// this.spots = [];
					// this.loadSpotNotFullVersion();
				});
			}
		});
	}
	loadSpotNotFullVersion() {
		this.route.parent.params.subscribe((params) => {
			this.serverService.getBuildingsByLivingComplexId(params.id).then((response) => {
				this.data = response;
				response.forEach((s) => {
					this.serverService.getSpotActDoc(s.spots.id).then((r1) => {
						s.spots.docs = r1;

						if (s.spots.docs.length === 0) {
							s.spots.calendarActVis = true;
						}
					});
					s.spots.stages = s.stages;

					this.spots.push(s.spots);
					this.spotColors = this.getColorOfSpots(this.spots);
					if (this.getLocalItem == '1') {
						this.spotColors = this.getColorOfSpots(this.spots);
						for (let i = 0; i < this.spots.length; i++) {
							this.spots[i].isOpen = this.openedSpotInfo[i].isOpen;
						}
					}
					s.stages.map((r2) => {
						r2.complete = Math.floor(r2.complete);
					});
				});

				if (this.spots.length > 0) {
					this.selectedSpotId = this.spots[0].id;
				}
				// this.loading = true;
			});
		});
	}

	loadSpotFullInfo(item) {
		this.serverService.getConstructionFullInfo(this.selectedIndex, this.floorID).then((res2) => {
			if (item != null) {
				for (let i = 0; i < this.selectedFlorInfo.length; i++) {
					res2[i].showChild = this.openedTreeInfo[i].showChild;
					for (let j = 0; j < this.selectedFlorInfo[i].categories.length; j++) {
						res2[i].categories[j].showChild = this.openedTreeInfo[i].categories[j].showChild;
						for (let k = 0; k < this.selectedFlorInfo[i].categories[j].categories.length; k++) {
							res2[i].categories[j].categories[k].showChild = this.openedTreeInfo[i].categories[
								j
							].categories[k].showChild;
							this.selectedFlorInfo = res2;
						}
					}
				}
			} else {
				this.selectedFlorInfo = res2;
			}
		});
	}

	getPortalLicense() {
		let user = JSON.parse(localStorage.getItem('user'));
		if (user && typeof user.roles !== 'undefined') {
			this.user = user;
		}
		if (!this.user.roles.some((e) => e === 'BDAdmin')) {
			this.serverService.getPortalLicense(1, 2).then((res) => {
				let result = res[0];
				if (result && typeof result.licenseParams !== 'undefined') {
					this.buildingsInfoForLicense = JSON.parse(result.licenseParams);
				}
			});
		}
	}

	allowAccesForFullVersion(buildingsInfoForLicense: BuildingInfoForLicense[], selectedSpot: ISpot) {
		let findSpot;
		if (buildingsInfoForLicense.length > 0 && selectedSpot) {
			findSpot = buildingsInfoForLicense.find((f) => f.buildingId === selectedSpot.id);
			if (findSpot) {
				this.foundSpot = findSpot;
				let currentDate = moment(new Date()).format('YYYY-MM-DD');
				if (this.foundSpot.endDate < currentDate) {
					this.foundSpot = {
						type: 1,
						message:
							'Срок действия вашей лицензии истек в ' + this.dateFormat.transform(this.foundSpot.endDate)
					};
				} else {
					this.foundSpot = {
						type: 2,
						message:
							'Срок действия лицензии истекает в ' + this.dateFormat.transform(this.foundSpot.endDate)
					};
					this.loadSpotFullInfo(null);
				}
			} else {
				// this.foundSpot = { "type": 1, "message": "Доступ запрещен! Приобретите лицензию для использования полной версии!" };
				this.foundSpot = { type: 1, message: '' };
			}
		} else {
			if (!this.user.roles.some((e) => e === 'BDAdmin')) {
				this.foundSpot = { type: 1, message: '' };
				// this.foundSpot = { "type": 1, "message": "Доступ запрещен! Приобретите лицензию для использования полной версии!" };
			} else {
				this.foundSpot = { type: 3, message: '' };
			}
			this.loadSpotFullInfo(null);
		}
	}

	getColorOfSpots(rows: ISpot[]) {
		let arr = [];
		rows.map((r) => {
			if (r.realisationPercent > 0 && r.realisationPercent < 100) {
				arr.push('violet');
			}
			if (r.realisationPercent === 0) {
				arr.push('');
			}
			if (r.realisationPercent === 100) {
				arr.push('green');
			}
		});
		return arr;
	}

	getInfoBuildingsStages(buildingID: number) {
		this.serverService.getLivingComplexInfo_BuildProcess(buildingID).then((res) => {
			this.ibuildingInfo = res;
		});
	}

	selectSpot(id: number) {
		this.selectedSpotId = id;
		this.getInfoBuildingsStages(this.selectedSpotId);
	}
	selectedSpotIndexToUp: number;
	openSpot(index: number) {
		this.spotForm = false;
		this.selectedIndex = this.spots[index].id;
		this.selectedSpotIndexToUp = index;
		if (this.selectedSpotIndex === index) {
			this.spots[index].isOpen = !this.spots[index].isOpen;
			if (this.spots[index].isOpen) {
				this.selectedSpot = this.spots[index];
			} else {
				this.selectedSpot = null;
			}
		} else {
			this.spots.map((r) => {
				r.isOpen = false;
			});
			this.spots[index].isOpen = true;
			this.selectedSpotIndex = index;
			this.selectedSpot = this.spots[index];
		}
		this.allowAccesForFullVersion(this.buildingsInfoForLicense, this.selectedSpot);
	}

	sendInfo(item: IConstructionInfo) {
		localStorage.setItem(this.sendLocalKey, '1');
		this.getLocalItem = localStorage.getItem(this.sendLocalKey);
		if (this.getLocalItem == '1') {
			item.showChild = true;
		}
		item.planValueEdit = false;
		this.openedTree(this.selectedFlorInfo);
		this.openedSpotInfo = this.spots;
		this.serverService.insertStages(item).then(
			() => {
				this.spots = [];
				this.loadSpotNotFullVersion();
				this.loadSpotFullInfo(item);
				this.toastr.success('Изменения сохранены!', 'Успешно!');
			},
			(err: any) => {
				if (err.status == 500 || err.status == 0) {
					this.toastr.error(
						'К сожалению, сервер временно недоступен. Попробуйте повторить действие чуть позже!',
						'Ваши данные не сохранены!'
					);
				}
			}
		);
	}

	openedTree(item: IConstructionInfo[]) {
		item.forEach((elem) => {
			elem.categories.forEach((value) => {
				if (value.showChild == true) {
					this.openedTreeInfo = item;
					return value;
				} else {
					if (value.showChild == false) {
						return this.averagePercent(value.categories);
					}
				}
			});
		});
	}

	openPlanInput(index: number, item: IConstructionInfo) {
		if (this.selectedPlanInput === index) {
			item.planValueEdit = !item.planValueEdit;
		} else {
			this.averagePercent(this.selectedFlorInfo);
			item.planValueEdit = true;
			this.selectedPlanInput = index;
		}
	}
	setFieldValue(index: number, item: IConstructionInfo, event) {
		if (event.keyCode == 13) {
			if (this.selectedPlanInput === index) {
				item.planValueEdit = !item.planValueEdit;
			} else {
				this.averagePercent(this.selectedFlorInfo);
				item.planValueEdit = true;
				this.selectedPlanInput = index;
			}
		}
	}

	averagePercent(item: IConstructionInfo[]) {
		item.forEach((elem) => {
			elem.planValueEdit = false;
			elem.categories.forEach((value) => {
				if (value.unitID !== 0) {
					return value;
				} else {
					if (value.categories.length !== 0) {
						return this.averagePercent(value.categories);
					}
				}
			});
		});
	}

	startCalendarOpen(item: IConstructionInfo) {
		this.startCalendarModal = true;
		this.currentStartCalendar = item;
	}

	endCalendarOpen(item: IConstructionInfo) {
		this.endCalendarModal = true;
		this.currentStartCalendar = item;
	}

	openTree(item: IConstructionInfo) {
		if (item) {
			item.showChild = !item.showChild;
		} else {
			item.categories.map((r) => {
				r.showChild = false;
			});
			item.showChild = true;
		}

		return 'margin';
	}

	acceptInfo(item: IConstructionInfo) {
		if (item.planValue != null && item.planFromDate != null && item.planToDate) {
			return 'activeInfo';
		} else {
			return 'notactiveInfo';
		}
	}

	getDate(timestamp: number) {
		if (timestamp == null) return '-';
		let date = new Date(timestamp);
		return date.getDate() + ' ' + this.getMonthName(date) + ' ' + date.getFullYear();
	}

	getMonthName(date: Date) {
		return this.event.getMonthName(date.getMonth() + 1, true, true);
	}
	openStageCalendar(spot: ISpot, stage: IStage) {
		if (stage.completeOpen === true || stage.start_date !== null) {
			this.calendarTitle = this.calendarTitleTemplate.replace('{stage}', stage.number.toString());
			this.calendarModal = true;
			this.activeSpot = spot;
			this.activeStage = stage;
			this.serverService.getBuildingStageFactValues(spot.id, stage.number).then((res) => {
				this.completeDates = res.vals;
				this.years = res.years;
				this.stageLoading = true;
			});
		} else alert('Выберите ГПР');
	}

	openPeriodModal(spot: ISpot, stage: IStage) {
		this.periodModal = true;
		this.stages = spot.stages;
		this.activeSpot = spot;
		this.activeStage = stage;
	}

	saveValues(event) {
		let spot;

		if (!this.objIsEmpty(event)) {
			this.completeDates = event;
			let request = [];
			let keys = Object.keys(this.completeDates);
			keys.forEach((key) => {
				request.push({
					buildingId: this.activeSpot.id,
					stageId: this.activeStage.number,
					factDate: parseInt(key),
					value: parseInt(this.completeDates[key])
				});
			});
			request.sort((a, b) => {
				if (a.factDate < b.factDate) return -1;
				if (a.factDate > b.factDate) return 1;
				return 0;
			});

			this.serverService.setBuildingStageFactValues(request).then(
				() => {
					this.toastr.success('Изменения сохранены!', 'Успешно!');
					spot = this.spots.filter((spot) => spot.id == this.activeSpot.id)[0];
					spot.stages.filter((stage) => stage.number == this.activeStage.number)[0].complete =
						request[request.length - 1].value;
				},
				(err: any) => {
					if (err.status == 500 || err.status == 0) {
						this.toastr.error(
							'К сожалению, сервер временно недоступен. Попробуйте повторить действие чуть позже!',
							'Ваши данные не сохранены!'
						);
					}
				}
			);
		} else {
			this.activeSpot.stages[this.activeStage.number - 1].complete = 0;
		}
	}

	objIsEmpty(obj) {
		for (var key in obj) {
			if (obj.hasOwnProperty(key)) return false;
		}
		return true;
	}

	calculateAveragePercent(stages: IStage[]) {
		let isset = stages.filter((s) => s.start_date != null && s.end_date != null);
		if (isset.length >= 7) {
			let avg = 0;
			isset.forEach((i) => {
				if (i.number != 8) {
					avg = avg + i.complete;
				}
			});
			if (avg > 0) {
				return Math.round(avg / 7) + '%';
			} else {
				return '-';
			}
		}
		return 0 + '%';
	}

	getTooltip(number: number) {
		let dic = [
			'Основания и фундаменты',
			'Несущие и огражд. конструкции выше отметки 0.000',
			'Внутренние стены и перегородки',
			'Окна и двери',
			'Внутренние системы',
			'Наружная отделка',
			'Внутренняя отделка',
			'Наружные сети (ИКИ)'
		];
		return dic[number - 1];
	}

	outputPeriodModal(event, isStartDate: boolean){
		if(isStartDate){
			this.activeStage.start_date = event;

		} else{
			this.activeStage.end_date = event;
			this.activeStage.completeOpen = true;
			this.save();
		}
		this.periodModal = false;
	}

	save() {
		let data = [];
		data.push({
			buildingId: this.activeSpot.id,
			stageId: this.activeStage.number,
			startDate: this.activeStage.start_date,
			endDate: this.activeStage.end_date
		});
		this.serverService.setPlanDates(data).then(
			(res) => {
				this.toastr.success('Изменения сохранены!', 'Успешно!');
				this.periodModal = false;
			},
			(err: any) => {
				if (err.status == 500 || err.status == 0) {
					this.toastr.error(
						'К сожалению, сервер временно недоступен. Попробуйте повторить действие чуть позже!',
						'Ваши данные не сохранены!'
					);
				}
			}
		);
	}

	graphicModal: boolean = false;
	selectedSpotEx: ISpot = null;
	openLineChart(spot: ISpot) {
		this.graphicModal = true;
		this.selectedSpotEx = spot;
	}
	durationLoading: boolean = false;
	uploadSpotActDocument(event, fileTypeId: number, spotId: number, spot) {
		let files = event;
		for (let i = 0; i < files.length; i++) {
			let fileType = files[i].type.substr(files[i].type.indexOf('/') + 1);
			this.serverService.uploadSpotActDocument(spotId, fileTypeId, files[i]).then((res) => {
				if (res.length > 0) {

					this.disCalendar = true;
					this.spots[spot].docs.push({
						dbFileID: res,
						documentTypeID: fileTypeId,
						fileExtension: '',
						fileName: res + '.' + fileType,
						updatedOn: ''
					});
				}
			});
		}
	}

	sendActDate(spot) {
		let currentDate = moment(this.spotDocDate).format('YYYY-MM-DD');

		this.serverService
			.setActDate(this.spots[this.selectedSpotIndexToUp].docs[0].dbFileID, currentDate)
			.then((r) => {
				spot.calendarActVis = false;
			});
	}
	deleteActDocument(fileID: number, file, spot) {
		this.serverService.delActFile(fileID).then((r) => {
			file.pop();
			spot.calendarActVis = true;
			this.disCalendar = false;
		});
	}
	calculate(v1: number, v2: number) {
		let t1 = 0;
		let t2 = 0;
		if (v1) {
			t1 = parseInt(v1.toString());
		}
		if (v2) {
			t2 = parseInt(v2.toString());
		}
		return t1 + t2;
	}


	clickProblem() {
		this.serverService.getTroubleQuestion(this.selectedIndex).then(res => {
			this.problemsQuestion = res;
		});
		this.problem = true;
	}

	cancelProblem() {
		this.problem = false;
	}

	confirmProblem() {
		this.serverService.setTroubleQuestion(this.livingComplexID, this.problemsQuestion);
		this.problem = false;
	}

	deleteProblem() {
		this.problemsQuestion = '';
	}


}

export interface IConstructionInfo {
	id: number;
	lvl: number;
	lvlTitle: string;
	rowNum: string;
	title: string;
	prodIndicatorTitle: string;
	unitID: number;
	unitTitle: string;
	stragePath: any;
	planValue: number;
	factValue: number;
	completionPercent: number;
	parentID: number;
	floorID: number;
	isReadyFlag: boolean;
	stageIsReady: boolean;
	showChild?: boolean;
	active?: boolean;
	planFromDate?: string;
	planToDate?: string;
	categories?: IConstructionInfo[];
	planValueEdit?: boolean;
	//openedStages?: boolean;
}

interface BuildingInfoForLicense {
	buildingId?: number;
	startDate?: string;
	endDate?: string;
	type?: number;
	message?: string;
}
